import React from 'react';
import { Route, Switch, BrowserRouter, Redirect } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { getOfferFromURL, LOG, isPathWithoutOffer } from '../helpers';

// pages
import Identify from '../pages/Identify';
import CreateUser from '../pages/CreateUser';
import Subscriber from '../pages/Subscriber';
import UserNotAllowed from '../pages/UserNotAllowed';
import Activation from '../pages/Activation';
import ActivationError from '../pages/Activation/Error';
import ActivationSuccess from '../pages/Activation/Success';
import UpdateUser from '../pages/UpdateUser/index';
import UpdateUserError from '../pages/UpdateUser/Error';
import NotFound from '../pages/NotFound';

import './style.scss';

const cache = {
  history: null,
  offerId: null
};

const preRender = (Element, { match }) => {
  cache.offerId = match.params.offerId;
  return <Element />;
};

// Do a push in navigation, to change url witout be inside a component react
const navigate = to => {
  cache.history.push({
    pathname: to,
    search: cache.history.location.search
  });
};

const offerId = getOfferFromURL();
LOG('[offerID]', offerId);
const routes = [
  {
    key: '/',
    path: '/',
    render: () => (
      <Redirect
        to={{ pathname: '/identifique-se', search: window.location.search }}
      />
    ),
    exact: true,
    effect: 'swipe'
  },
  {
    key: `/${offerId}`,
    path: `/${offerId}`,
    render: () => (
      <Redirect
        to={{ pathname: '/identifique-se', search: window.location.search }}
      />
    ),
    exact: true,
    effect: 'swipe'
  },
  {
    key: '/identifique-se',
    path: '/identifique-se',
    render: context => preRender(Identify, context),
    exact: true,
    effect: 'swipe'
  },
  {
    key: '/cadastro',
    path: '/cadastro',
    render: context => preRender(CreateUser, context),
    exact: true,
    effect: 'swipe'
  },
  {
    key: '/confirmar-cpf',
    path: '/confirmar-cpf',
    render: context => preRender(UpdateUser, context),
    exact: true,
    effect: 'swipe'
  },
  {
    key: '/confirmar-cpf/erro',
    path: '/confirmar-cpf/erro',
    render: context => preRender(UpdateUserError, context),
    exact: true,
    effect: 'swipe'
  },
  {
    key: '/usuario-assinante',
    path: '/usuario-assinante',
    render: context => preRender(Subscriber, context),
    exact: true,
    effect: 'swipe'
  },
  {
    key: '/ativacao',
    path: '/ativacao',
    render: context => preRender(Activation, context),
    exact: true,
    effect: 'swipe'
  },
  {
    key: '/ativacao/erro',
    path: '/ativacao/erro',
    render: context => preRender(ActivationError, context),
    exact: true,
    effect: 'swipe'
  },
  {
    key: '/ativacao/sucesso',
    path: '/ativacao/sucesso',
    render: context => preRender(ActivationSuccess, context),
    exact: true,
    effect: 'swipe'
  },
  {
    key: '/ativacao/erro-usuario',
    path: '/ativacao/erro-usuario',
    render: context => preRender(UserNotAllowed, context),
    exact: true,
    effect: 'swipe'
  },
  {
    key: '/not-found',
    path: '*',
    render: context => preRender(NotFound, context),
    exact: true,
    effect: 'fade'
  }
];

const AppRouter = () => {
  if (isPathWithoutOffer()) {
    window.location.href = `/${offerId}/identifique-se${window.location.search}`;
  }
  return (
    <BrowserRouter basename={`/${offerId}`}>
      <Route
        render={({ history, location }) => {
          cache.history = history;
          return (
            <TransitionGroup className="app-router-container">
              <CSSTransition
                key={location.pathname}
                classNames="app-router-effect"
                timeout={{ enter: 800, exit: 800 }}
              >
                <Switch location={location}>
                  {routes.map(route => (
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    <Route {...route} />
                  ))}
                </Switch>
              </CSSTransition>
            </TransitionGroup>
          );
        }}
      />
    </BrowserRouter>
  );
};

export { AppRouter, routes, navigate };

export default AppRouter;
